import { useState } from 'react';
import { useLocation } from 'react-router';
import UserDetails from './ForgottenPasswordForm/UserDetails';
import Confirmation from './ForgottenPasswordForm/Confirmation';
import { FormData } from './types';

const ForgottenPassword = () => {
  const { state } = useLocation();
  // TODO: Remove this when SSO flow is implemented
  const backUrl = state?.ssoFlow ? '/signin/password' : '/signin';
  const INITIAL_DATA = {
    emailAddress: '',
  };
  const [form, setForm] = useState(INITIAL_DATA);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const updateForm = (formData: FormData) => {
    setForm((previousState: FormData) => ({
      ...previousState,
      ...formData,
    }));
  };
  return showConfirmation ? (
    <Confirmation emailAddress={form.emailAddress} backUrl={backUrl} />
  ) : (
    <UserDetails
      setShowConfirmation={setShowConfirmation}
      update={updateForm}
      backUrl={backUrl}
    />
  );
};

export default ForgottenPassword;
